<template>
  <div class="page border-box" v-wechat-title="$route.meta.title">

    <div class="bus-tit">桂东县域内公共汽车班次时刻表</div>

    <div class="bus-list">
      <div class="blist-box">
        <div class="blist-tit">101线 增口——松山 <span class="fr">7里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">增口</p><p class="border-box name">松山</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">始班7:15、未班17:25</p><p class="border-box time">始班7:00、未班17:45</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box tag">每15分钟一趟</p><p class="border-box time">每15分钟一趟</p>
        </div>
      </div>

      <div class="blist-box">
        <div class="blist-tit">102线 三洞——政务中心 <span class="fr">11里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">三洞</p><p class="border-box name">政务中心</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">始班7:10、未班17:05</p><p class="border-box time">始班7:00、未班17:45</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box tag">每1个半小时一趟</p><p class="border-box time">每1个半小时一趟</p>
        </div>
        <p class="blist-tip">(注：禾坪每天一趟，11:55)</p>
      </div>

      <div class="blist-box">
        <div class="blist-tit">103线 增口——光明 <span class="fr">8里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">增口</p><p class="border-box name">光明</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">始班7:07、未班17:40</p><p class="border-box time">始班6:45、未班18:10</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box tag">每15分钟一趟</p><p class="border-box time">每15分钟一趟</p>
        </div>
      </div>

      <div class="blist-box">
        <div class="blist-tit">105线 坪水——政务中心 <span class="fr">11里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">坪水</p><p class="border-box name">政务中心</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">始班7:00、未班17:30</p><p class="border-box time">始班8:10、未班17:10</p>
        </div>
      </div>

      <div class="blist-box">
        <div class="blist-tit">107线 桂东——万洋山 <span class="fr">35里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">桂东</p><p class="border-box name">万洋山</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">桂东-下东-秋里-万洋山：6:50、(12:00 桂东-下东) 15:30</p>
          <p class="border-box time">万洋山-秋里-下东-桂东：8:00、(12:00 下东-桂东) 16:40</p>
        </div>
      </div>

      <div class="blist-box">
        <div class="blist-tit">111线 桂东——青竹 <span class="fr">24里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">桂东</p><p class="border-box name">青竹</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">桂东-青竹：6:40、12:00、15:40</p>
          <p class="border-box time">青竹-桂东：7:20、12:40、16:20</p>
        </div>
      </div>

      <div class="blist-box">
        <div class="blist-tit">115线 桂东——大洞 <span class="fr">12里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">桂东</p><p class="border-box name">大洞</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">桂东-大洞：8:00、11:20</p>
          <p class="border-box time">大洞-桂东：8:20、11:40</p>
        </div>
        <p class="blist-tip">(注：线路为暑期旅游线路，运行时间为8月-9月)</p>
      </div>

      <div class="blist-box">
        <div class="blist-tit">211线 桂东——流源沙坑 <span class="fr">21里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">桂东</p><p class="border-box name">沙坑</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">始班6:20、未班16:00</p><p class="border-box time">始班7:00、未班17:00</p>
        </div>
      </div>

      <div class="blist-box">
        <div class="blist-tit">211线 桂东——沙田 <span class="fr">37里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">桂东</p><p class="border-box name">沙田</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">始班6:30、未班20:00</p><p class="border-box time">始班6:30、未班20:00</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box tag">每30分钟一趟</p><p class="border-box time">每30分钟一趟</p>
        </div>
      </div>

      <div class="blist-box">
        <div class="blist-tit">283线 桂东——八面山 <span class="fr">94里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">桂东</p><p class="border-box name">八面山</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">桂东：12:20</p><p class="border-box time">八面山：6:30</p>
        </div>
        <p class="blist-tip">(注：四都赶集日运行)</p>
      </div>

      <div class="blist-box">
        <div class="blist-tit">391线 桂东——清泉 <span class="fr">36里程(Km)</span></div>
        <div class="blist-li clearfix">
          <p class="border-box name">桂东</p><p class="border-box name">清泉</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box time">始班7:00、未班16:20</p><p class="border-box time">始班6:30、未班16:30</p>
        </div>
        <div class="blist-li clearfix">
          <p class="border-box tag">每1小时一趟</p><p class="border-box time">每1小时一趟</p>
        </div>
      </div>

    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>

  </div>

</template>

<script>
  import Swiper from '../../components/Swiper'
  import AlertComment from '../../components/AlertComment'
  import {mapSpotDetail,mapServiceDetail,mapSpotComment} from "@/service/getData";
  import {wxGetPosition,wxShareme,listenEndOrder, getWxMini,wxImgPreview} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import P400 from '../../components/P400'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        shopid: this.$route.query.shopid || '', //景区id
        userInfo: {}, //用户信息
        loadText: "数据加载中",

        appKey: '',
        appKeyA: '',


        P400: 0, //系统维护中

        isWxMini: false, //返回是否是小程序环境
      }
    },
    computed: {

    },
    created(){

      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }

    },

    methods: {

    },

    components: {
        P400
    },

  }

</script>

<style scoped>
  @import '../../style/alert.css';

  .page{ padding: .24rem .24rem .6rem; min-height: 100vh; overflow-x: hidden;background-color: #f6f6f6;}

  .bus-tit{font-size: .34rem;font-weight: bold;color: #dd4b39;text-align: center;}

  .blist-box{padding: .26rem .24rem .3rem; margin-top:.3rem;background-color: #fff;border-radius: .24rem;box-shadow: 0 10px 15px #e5e5e5;}
  .blist-tit{font-size: .3rem;font-weight: bold;color: #333;line-height: .42rem;margin-bottom: .2rem;}
  .blist-tit .fr{font-size: .22rem;font-weight: normal;color: #666;}
  .blist-li p{ float: left; width: 50%; font-size: .26rem;color: #333;line-height: .34rem; padding: .15rem 0; text-align: center;border: .01rem solid #ccc;border-bottom: none;border-right: none; }
  .blist-li p:last-child{border-right: .01rem solid #ccc;}
  .blist-box .blist-li:last-of-type p{border-bottom: .01rem solid #ccc;}
  .blist-li .name{font-weight: bold;}
  .blist-tip{font-size: .24rem;color: #f20;text-align: right;margin-top: .1rem;}

</style>



// WEBPACK FOOTER //
// src/page/map/map-bus.vue